import { useTranslation } from 'react-i18next'
import type { EHandName } from '../../../types/enums'
import { EEvent } from '../../../types/enums'
import { CardsBlock } from '..'
import * as styles from './index.css'

export const EventLogItem = (props: {
  event: EEvent
  timestamp: Date
  name: string | null
  handNumber: number
  handName: EHandName
  bank?: number
  cards: string | null
  communityCards: string | null
  bet?: number
}) => {
  const { t } = useTranslation()

  if (props.event === EEvent.Win) {
    return (
      <div className={styles.eventContainer}>
        <div className={styles.eventBody}>
          <div className={styles.playerLine}>
            {t('modal.chat.label.player')}: <strong>{props.name}</strong>
          </div>
          <div>
            {t('modal.chat.label.combination')}:{' '}
            <strong>
              {props.handName ? t(`table.handName.${props.handName}`) : '—'}
            </strong>
          </div>
          {props.bank && props.bank > 0 && (
            <span>
              {t('modal.chat.label.bank')}: {props.bank}
            </span>
          )}
          {props.cards && props.communityCards && (
            <div className={styles.cardsWrapper}>
              <CardsBlock cards={props.cards} />
              <CardsBlock cards={props.communityCards} />
            </div>
          )}
        </div>
      </div>
    )
  }

  if (props.event === EEvent.Deal) {
    return (
      <div className={styles.logLine}>
        {t('modal.chat.label.round', {
          handNumber: props.handNumber,
        })}
      </div>
    )
  }

  if (
    props.event === EEvent.Bet ||
    props.event === EEvent.Raise ||
    props.event === EEvent.Call
  ) {
    if (!props.bet || props.bet <= 0) {
      return null
    }

    return (
      <div className={styles.logLine}>
        {t(`modal.chat.label.event.${props.event}`, {
          amount: props.bet,
          name: props.name,
        })}
      </div>
    )
  }

  return (
    <div className={styles.logLine}>
      {t(`modal.chat.label.event.${props.event}`, {
        name: props.name,
      })}
    </div>
  )
}
